"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var Switch = _interopRequireWildcard(require("@radix-ui/react-switch"));
var _HBTooltip = _interopRequireDefault(require("../HBTooltip/HBTooltip"));
var _Eye = _interopRequireDefault(require("@honeybook/icons/dist/icons/Eye16"));
var _EyeCrossed = _interopRequireDefault(require("@honeybook/icons/dist/icons/EyeCrossed16"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBVisibilitySwitch = function HBVisibilitySwitch(_ref) {
  var checked = _ref.checked,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    tooltipContent = _ref.tooltipContent,
    label = _ref.label,
    dataTestid = _ref['data-testid'],
    id = _ref.id,
    className = _ref.className;
  var switchCmp = /*#__PURE__*/_react["default"].createElement(Root, {
    checked: checked,
    onCheckedChange: onChange,
    disabled: disabled
    // this is required to preserve existing testim.io functionality
    ,
    "data-testid": dataTestid || "".concat(id, "-label"),
    id: id,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(Thumb, {
    disabled: disabled,
    "aria-label": checked ? "".concat(label, " visibility on") : "".concat(label, " visibility off")
  }, checked ? /*#__PURE__*/_react["default"].createElement(_Eye["default"], {
    hoverColor: _colors["default"].neutral700
  }) : /*#__PURE__*/_react["default"].createElement(_EyeCrossed["default"], {
    hoverColor: _colors["default"].neutral700
  })));
  return /*#__PURE__*/_react["default"].createElement(_HBTooltip["default"], {
    target: switchCmp,
    placement: "top",
    disabled: !tooltipContent
  }, tooltipContent && (checked ? tooltipContent.checked : tooltipContent.unchecked));
};
var _default = exports["default"] = HBVisibilitySwitch;
var Root = (0, _styledComponents["default"])(Switch.Root).withConfig({
  displayName: "HBVisibilitySwitch__Root",
  componentId: "sc-15qtr1m-0"
})(["border:none;background:none !important;cursor:", ";", ";line-height:1;outline:revert;"], function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.disabled && 'opacity: 0.3';
});
var Thumb = (0, _styledComponents["default"])(Switch.Thumb).withConfig({
  displayName: "HBVisibilitySwitch__Thumb",
  componentId: "sc-15qtr1m-1"
})(["i{display:flex;}"]);
//# sourceMappingURL=HBVisibilitySwitch.js.map